module.exports = __webpack_public_path__ + "img/eff01.57216720.png";